import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import HeaderHiragana from "../components/HeaderHiragana";
import "./Hiragana.css";

const Hiragana = () => {
  const [romajiVowelKeyEntries, setRomajiVowelKeyEntries] = useState([]);
  const [vowelEntries, setVowelEntries] = useState([]);
  const [kEntries, setKEntries] = useState([]);
  const [sEntries, setSEntries] = useState([]);
  const [tEntries, setTEntries] = useState([]);
  const [nEntries, setNEntries] = useState([]);
  const [hEntries, setHEntries] = useState([]);
  const [mEntries, setMEntries] = useState([]);
  const [yEntries, setYEntries] = useState([]);
  const [rEntries, setREntries] = useState([]);
  const [wEntries, setWEntries] = useState([]);

  const [gEntries, setGEntries] = useState([]);
  const [zEntries, setZEntries] = useState([]);
  const [dEntries, setDEntries] = useState([]);
  const [bEntries, setBEntries] = useState([]);
  const [pEntries, setPEntries] = useState([]);

  const [romajiVowelKeyExceptionEntries, setRomajiVowelKeyExceptionEntries] =
    useState([]);
  const [yoonKEntries, setyoonKEntries] = useState([]);
  const [yoonSEntries, setyoonSEntries] = useState([]);
  const [yoonTEntries, setyoonTEntries] = useState([]);
  const [yoonNEntries, setyoonNEntries] = useState([]);
  const [yoonHEntries, setyoonHEntries] = useState([]);
  const [yoonMEntries, setyoonMEntries] = useState([]);
  const [yoonREntries, setyoonREntries] = useState([]);
  const [yoonGEntries, setyoonGEntries] = useState([]);
  const [yoonZEntries, setyoonZEntries] = useState([]);
  const [yoonDEntries, setyoonDEntries] = useState([]);
  const [yoonBEntries, setyoonBEntries] = useState([]);
  const [yoonPEntries, setyoonPEntries] = useState([]);

  const [showRomajiGojuon, setShowRomajiGojuon] = useState(false);
  const [showRomajiDakuten, setShowRomajiDakuten] = useState(false);
  const [showRomajiYoon, setShowRomajiYoon] = useState(false);

  const [isOpenGojuon, setIsOpenGojuon] = useState(false);
  const [isOpenDakuten, setIsOpenDakuten] = useState(false);
  const [isOpenYoon, setIsOpenYoon] = useState(false);

  useEffect(() => {
    const fetchAndDisplayHiragana = async () => {
      try {
        const response = await fetch("/db/db.json");
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();

        // Romaji Keys
        const romajiVowelKeySeries = data.romajiKey.romajiVowelKeySeries;
        const romajiKeyData = Object.keys(romajiVowelKeySeries).map((key) => ({
          romajiKey: romajiVowelKeySeries[key].romajiKey,
          romaji: key,
        }));
        setRomajiVowelKeyEntries(romajiKeyData);

        // SeriesVowel
        const seriesVowel = data.hiragana.seriesVowel;
        const vowelData = Object.keys(seriesVowel).map((key) => ({
          hiragana: seriesVowel[key].hiragana,
          romaji: key,
        }));
        setVowelEntries(vowelData);

        // SeriesK
        const seriesK = data.hiragana.seriesK;
        const kData = Object.keys(seriesK).map((key) => ({
          hiragana: seriesK[key].hiragana,
          romaji: key,
        }));
        setKEntries(kData);

        // SeriesS
        const seriesS = data.hiragana.seriesS;
        const sData = Object.keys(seriesS).map((key) => ({
          hiragana: seriesS[key].hiragana,
          romaji: key,
        }));
        setSEntries(sData);

        // SeriesT
        const seriesT = data.hiragana.seriesT;
        const tData = Object.keys(seriesT).map((key) => ({
          hiragana: seriesT[key].hiragana,
          romaji: key,
        }));
        setTEntries(tData);

        // SeriesN
        const seriesN = data.hiragana.seriesN;
        const nData = Object.keys(seriesN).map((key) => ({
          hiragana: seriesN[key].hiragana,
          romaji: key,
        }));
        setNEntries(nData);

        // SeriesH
        const seriesH = data.hiragana.seriesH;
        const hData = Object.keys(seriesH).map((key) => ({
          hiragana: seriesH[key].hiragana,
          romaji: key,
        }));
        setHEntries(hData);

        // SeriesM
        const seriesM = data.hiragana.seriesM;
        const mData = Object.keys(seriesM).map((key) => ({
          hiragana: seriesM[key].hiragana,
          romaji: key,
        }));
        setMEntries(mData);

        // SeriesY
        const seriesY = data.hiragana.seriesY;
        const yData = Object.keys(seriesY).map((key) => ({
          hiragana: seriesY[key].hiragana,
          romaji: key,
        }));
        setYEntries(yData);

        // SeriesR
        const seriesR = data.hiragana.seriesR;
        const rData = Object.keys(seriesR).map((key) => ({
          hiragana: seriesR[key].hiragana,
          romaji: key,
        }));
        setREntries(rData);

        // SeriesW
        const seriesW = data.hiragana.seriesW;
        const wData = Object.keys(seriesW).map((key) => ({
          hiragana: seriesW[key].hiragana,
          romaji: key,
        }));
        setWEntries(wData);

        // SeriesG
        const seriesG = data.dakuten.seriesG;
        const gData = Object.keys(seriesG).map((key) => ({
          hiragana: seriesG[key].hiragana,
          romaji: key,
        }));
        setGEntries(gData);

        // SeriesZ
        const seriesZ = data.dakuten.seriesZ;
        const zData = Object.keys(seriesZ).map((key) => ({
          hiragana: seriesZ[key].hiragana,
          romaji: key,
        }));
        setZEntries(zData);

        // SeriesD
        const seriesD = data.dakuten.seriesD;
        const dData = Object.keys(seriesD).map((key) => ({
          hiragana: seriesD[key].hiragana,
          romaji: key,
        }));
        setDEntries(dData);

        // SeriesB
        const seriesB = data.dakuten.seriesB;
        const bData = Object.keys(seriesB).map((key) => ({
          hiragana: seriesB[key].hiragana,
          romaji: key,
        }));
        setBEntries(bData);

        // SeriesZ
        const seriesP = data.dakuten.seriesP;
        const pData = Object.keys(seriesP).map((key) => ({
          hiragana: seriesP[key].hiragana,
          romaji: key,
        }));
        setPEntries(pData);

        // Romaji Keys For Yoon
        const romajiVowelKeyExceptionSeries =
          data.romajiKey.romajiVowelKeyExceptionSeries;
        const romajiKeyExceptionData = Object.keys(
          romajiVowelKeyExceptionSeries,
        ).map((key) => ({
          romajiKey: romajiVowelKeyExceptionSeries[key].romajiKey,
          romaji: key,
        }));
        setRomajiVowelKeyExceptionEntries(romajiKeyExceptionData);

        // Serie Yoon K
        const seriesYoonK = data.yoon.seriesK;
        const ykData = Object.keys(seriesYoonK).map((key) => ({
          hiragana: seriesYoonK[key].hiragana,
          romaji: key,
        }));
        setyoonKEntries(ykData);

        // Serie Yoon S
        const seriesYoonS = data.yoon.seriesS;
        const ysData = Object.keys(seriesYoonS).map((key) => ({
          hiragana: seriesYoonS[key].hiragana,
          romaji: key,
        }));
        setyoonSEntries(ysData);

        // Serie Yoon T
        const seriesYoonT = data.yoon.seriesT;
        const ytData = Object.keys(seriesYoonT).map((key) => ({
          hiragana: seriesYoonT[key].hiragana,
          romaji: key,
        }));
        setyoonTEntries(ytData);

        // Serie Yoon N
        const seriesYoonN = data.yoon.seriesN;
        const ynData = Object.keys(seriesYoonN).map((key) => ({
          hiragana: seriesYoonN[key].hiragana,
          romaji: key,
        }));
        setyoonNEntries(ynData);

        // Serie Yoon H
        const seriesYoonH = data.yoon.seriesH;
        const yhData = Object.keys(seriesYoonH).map((key) => ({
          hiragana: seriesYoonH[key].hiragana,
          romaji: key,
        }));
        setyoonHEntries(yhData);

        // Serie Yoon M
        const seriesYoonM = data.yoon.seriesM;
        const ymData = Object.keys(seriesYoonM).map((key) => ({
          hiragana: seriesYoonM[key].hiragana,
          romaji: key,
        }));
        setyoonMEntries(ymData);

        // Serie Yoon R
        const seriesYoonR = data.yoon.seriesR;
        const yrData = Object.keys(seriesYoonR).map((key) => ({
          hiragana: seriesYoonR[key].hiragana,
          romaji: key,
        }));
        setyoonREntries(yrData);

        // Serie Yoon G
        const seriesYoonG = data.yoon.seriesG;
        const ygData = Object.keys(seriesYoonG).map((key) => ({
          hiragana: seriesYoonG[key].hiragana,
          romaji: key,
        }));
        setyoonGEntries(ygData);

        // Serie Yoon Z
        const seriesYoonZ = data.yoon.seriesZ;
        const yzData = Object.keys(seriesYoonZ).map((key) => ({
          hiragana: seriesYoonZ[key].hiragana,
          romaji: key,
        }));
        setyoonZEntries(yzData);

        // Serie Yoon D
        const seriesYoonD = data.yoon.seriesD;
        const ydData = Object.keys(seriesYoonD).map((key) => ({
          hiragana: seriesYoonD[key].hiragana,
          romaji: key,
        }));
        setyoonDEntries(ydData);

        // Serie Yoon B
        const seriesYoonB = data.yoon.seriesB;
        const ybData = Object.keys(seriesYoonB).map((key) => ({
          hiragana: seriesYoonB[key].hiragana,
          romaji: key,
        }));
        setyoonBEntries(ybData);

        // Serie Yoon P
        const seriesYoonP = data.yoon.seriesP;
        const ypData = Object.keys(seriesYoonP).map((key) => ({
          hiragana: seriesYoonP[key].hiragana,
          romaji: key,
        }));
        setyoonPEntries(ypData);
      } catch (error) {
        console.error("Error fetching hiragana data:", error);
      }
    };

    fetchAndDisplayHiragana();
  }, []);

  return (
    <div>
      <Header />
      <HeaderHiragana />

      <div className="contContainer">
        <div id="gojuon" className="gojuonContainer">
          <div className="gojuonDisplay">
            <div className="infoTitle">Grundtecken (gojūon)</div>

            <div className="romajiButton">
              <h3>Tryck här för att även se kanans tillhörande rōmaji.</h3>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={showRomajiGojuon}
                  onChange={() => setShowRomajiGojuon(!showRomajiGojuon)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="hiraganaDisplay">
              {romajiVowelKeyEntries.map((entry, index) => (
                <h1
                  className={index === 0 ? "emptySlot" : "singleKeyRomaji"}
                  key={index}
                >
                  {entry.romajiKey}
                </h1>
              ))}

              {vowelEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1 className={index === 0 ? "emptySlot" : "singleHiragana"}>
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {kEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {sEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {tEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {nEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {hEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {mEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {rEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {wEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiGojuon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}
            </div>
            <div
              className={`infoButtonGojuon ${isOpenGojuon ? "active" : ""}`}
              onClick={() => setIsOpenGojuon(!isOpenGojuon)}
            >
              <h2>Gojūon</h2>
              <img
                className="buttonIconGojuon"
                src="https://img.icons8.com/ios/50/circled-chevron-right--v1.png"
                alt="Open/close"
              />
            </div>
            <div className={`infoBoxGojuon ${isOpenGojuon ? "open" : ""}`}>
              {" "}
              <h2>
                Gojūon, trots sitt namn, har idag endast 46 tecken. Yi, ye och
                wu existerade aldrig, medan wi{" "}
                <span style={{ fontFamily: "Arial", fontSize: "1rem" }}>
                  (ゐ){" "}
                </span>
                och we{" "}
                <span style={{ fontFamily: "Arial", fontSize: "1rem" }}>
                  (ゑ)
                </span>{" "}
                användes i klassisk japanska men avskaffades i stavningsreformen
                1946.
                <br />
                <br />
                <span style={{ fontFamily: "Arial", fontSize: "1rem" }}>
                  ん
                </span>{" "}
                ("n") är den enda kana inom hiragana som inte slutar med ett
                vokalljud och tillhör traditionellt sett inte Gojūon-tabellen.
              </h2>
            </div>
          </div>
        </div>

        <div id="dakuten" className="gojuonContainer">
          <div className="gojuonDisplay">
            <div className="infoTitle">Dakuten & Handakuten</div>

            <div className="romajiButton">
              <h3>Tryck här för att även se kanans tillhörande rōmaji.</h3>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={showRomajiDakuten}
                  onChange={() => setShowRomajiDakuten(!showRomajiDakuten)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="hiraganaDisplay">
              {romajiVowelKeyEntries.map((entry, index) => (
                <h1
                  className={index === 0 ? "emptySlot" : "singleKeyRomaji"}
                  key={index}
                >
                  {entry.romajiKey}
                </h1>
              ))}

              {gEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiDakuten && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {zEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiDakuten && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {dEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiDakuten && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {bEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiDakuten && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {pEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={index === 0 ? "firstHiragana" : "singleHiragana"}
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiDakuten && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}
            </div>
            <div
              className={`infoButtonDakuten ${isOpenDakuten ? "active" : ""}`}
              onClick={() => setIsOpenDakuten(!isOpenDakuten)}
            >
              <h2>Dakuten & Handakuten</h2>
              <img
                className="buttonIconDakuten"
                src="https://img.icons8.com/ios/50/circled-chevron-right--v1.png"
                alt="Open/close"
              />
            </div>
            <div className={`infoBoxDakuten ${isOpenDakuten ? "open" : ""}`}>
              {" "}
              <h2>
                Dakuten
                <span style={{ fontFamily: "Arial", fontSize: "2rem" }}>
                  {" "}
                  ゛{" "}
                </span>
                och handakuten
                <span style={{ fontFamily: "Arial", fontSize: "2rem" }}>
                  ゜{" "}
                </span>
                är små markeringar som ändrar uttalet av vissa tecken.
              </h2>
            </div>
          </div>
        </div>

        <div id="yoon" className="gojuonContainer">
          <div className="gojuonDisplay">
            <div className="infoTitle">Yōon</div>

            <div className="romajiButton">
              <h3>Tryck här för att även se kanans tillhörande rōmaji.</h3>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={showRomajiYoon}
                  onChange={() => setShowRomajiYoon(!showRomajiYoon)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <div className="hiraganaDisplay">
              {romajiVowelKeyExceptionEntries.map((entry, index) => (
                <h1
                  className={index === 0 ? "emptySlot" : "singleKeyRomaji"}
                  key={index}
                >
                  {entry.romajiKey}
                </h1>
              ))}

              {yoonKEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonSEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonTEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonNEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonHEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonMEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonREntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonGEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonZEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonDEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonBEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}

              {yoonPEntries.map((entry, index) => (
                <div
                  key={index}
                  style={{ position: "relative", display: "inline-block" }}
                >
                  <h1
                    className={
                      index === 0
                        ? "firstHiragana"
                        : entry.hiragana === ""
                          ? "emptySlotHiragana"
                          : "singleHiragana"
                    }
                  >
                    {entry.hiragana}
                  </h1>
                  {showRomajiYoon && entry.hiragana !== "" && (
                    <div className="romajiKeyDisplay">{entry.romaji}</div>
                  )}
                </div>
              ))}
            </div>
            <div
              className={`infoButtonYoon ${isOpenYoon ? "active" : ""}`}
              onClick={() => setIsOpenYoon(!isOpenYoon)}
            >
              <h2>Yōon</h2>
              <img
                className="buttonIconYoon"
                src="https://img.icons8.com/ios/50/circled-chevron-right--v1.png"
                alt="Open/close"
              />
            </div>
            <div className={`infoBoxYoon ${isOpenYoon ? "open" : ""}`}>
              {" "}
              <h2>
                Yōon är kombinationstecken där ett litet{" "}
                <span style={{ fontFamily: "Arial", fontSize: "1rem" }}>
                  や、ゆ{" "}
                </span>
                eller{" "}
                <span style={{ fontFamily: "Arial", fontSize: "1rem" }}>
                  よ{" "}
                </span>
                kombineras med vissa tecken för att skapa nya ljud
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hiragana;
